export const SET_CURRENTUSER = 'SET_CURRENTUSER';
export const SET_USERPROFILE = 'SET_USERPROFILE';
export const SET_LASTPOS = 'SET_LASTPOS';
export const SET_LASTPOSMINUS = 'SET_LASTPOSMINUS';
export const SET_STATENULL = 'SET_STATENULL';
export const SET_STATE = 'SET_STATE';

export default {
    [SET_CURRENTUSER](state, val) {
        state.currentUser = val;
    },
    [SET_STATE](state, val) {
        state.state = val;
    },
    [SET_USERPROFILE](state, val) {
        state.userProfile = val;
    },
    [SET_LASTPOS]: (state, product) => {
        state.userProfile.last_position = Number(product) + Number(1);
    },
    [SET_LASTPOSMINUS]: (state, product) => {
        state.userProfile.last_position =
            Number(state.userProfile.last_position) - Number(product);
    },
    [SET_STATENULL]: (state, product) => {
        state.userProfile.last_position = Number(0);
    },
};